import React from "react";

import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material";
import { observer } from "mobx-react-lite";

import useGlobalSnackbar from "@/hooks/useGlobalSnackbar";

import { PlannedMeal } from "../../store/PlannedMeal";

interface Props {
  open: boolean;
  plannedMeal: PlannedMeal;
  onClose: () => void;
}

const DeletePlannedMealDialog: React.FC<Props> = observer(
  ({ open, plannedMeal, onClose }) => {
    const snackbar = useGlobalSnackbar();

    const handleConfirm = () => {
      plannedMeal.remove();
      onClose();
      snackbar.open(`${plannedMeal.label} has been deleted`);
    };

    return (
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>Delete {plannedMeal.label}?</DialogTitle>
        <DialogActions>
          <Button variant="text" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="text" onClick={handleConfirm}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
);

export default DeletePlannedMealDialog;
